import { expressionDefinitionApiV2 } from 'app/services/api';

import { createNamedActions } from 'utils/namedActionTypesProxy';

export const SCHEMA_ACTION_TYPE = createNamedActions('marginCenter/schema', {
  SET_MARGIN_SCHEMA: 'SET_MARGIN_SCHEMA',
});

// The ExpressionField's autocomplete/validation object model — roots Application/Channel/Loan/Program,
// the same shape adjustments fetches (MarginExpressionContextBuilder mirrors AdjustmentExpressionContext).
// A failed fetch degrades to an empty schema (editor renders without autocomplete) rather than blocking
// the page, matching the rest of Margin Center's forbidden-reload-skipping degrade philosophy.
export const getMarginSchemaAction = () => async dispatch => {
  try {
    const { data } = await expressionDefinitionApiV2.getMarginSchemaExpressionDefinition();

    return dispatch({ type: SCHEMA_ACTION_TYPE.SET_MARGIN_SCHEMA, payload: data });
  } catch {
    return dispatch({ type: SCHEMA_ACTION_TYPE.SET_MARGIN_SCHEMA, payload: null });
  }
};
